export default class User {
  constructor(username, email, password) {
    this.username = username;
    this.email = email;
    this.password = password;
    this.survey = false;
    this.newsletter = false;
    this.onetimecode = null;
    this.avatar = null;
    this.activated = false;
    this.preregistered = false;
  }
}
